import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { composeMiddleware } from "@/store2/middleware";
import { StoreGet, StoreSet } from "@/types";

import { commonActions } from "@/store2/common";
import { ActivityTypeCode, PaymentTypeCode } from "project-config/constants";
import {
  IFoxTopUpAction,
  IFoxTopUpState,
  IFoxTopUpStore,
  IVerifyRechargeCodeParams,
} from "../types";
import { CouponType } from "../constants/fox-balance-info";
import { FoxTopUpAPI } from "./service";

export const initVerifyRechargeInfo = {
  activityId: 0,
  couponAmount: 0,
  couponNO: "",
  rechargeAmount: 0,
  couponType: CouponType.Universal,
};

const initialState = (): IFoxTopUpState => {
  return {
    activeName: "",
    rechargeSecondActiveName: "", // 充值tab的二级tab
    activityInfoList: [], // 除抽奖活动外的活动
    luckDrawGiftActivityInfo: null, // 抽奖活动
    lotteryActivityInfoList: [], // 抽奖券信息
    HangTags: [], // 常规充值
    checkedRadioId: 0,
    amount: 0,
    payMethod: PaymentTypeCode.Paypal,
    isCheckCard: true,
    showCouponCodeModal: false,
    inputCode: "",
    verifyRechargeInfo: initVerifyRechargeInfo,
    loading: false,
  };
};

const getter = (get: StoreGet<IFoxTopUpStore>) => ({
  // 是否存在充值赠送券活动
  haveRechargeGiftCouponActivity: () => {
    const { activityInfoList } = get();
    return activityInfoList.some(
      (item) => item.activityType === ActivityTypeCode.RechargeGift
    );
  },
  // 充值赠送券活动
  rechargeGiftCouponActivity: () => {
    const { activityInfoList, haveRechargeGiftCouponActivity } = get();
    if (haveRechargeGiftCouponActivity()) {
      const rechargeGiftActivity = activityInfoList.find(
        (item) => item.activityType === ActivityTypeCode.RechargeGift
      );
      const obj = rechargeGiftActivity?.activityDetail.reduce(
        (acc: any, curr) => {
          const key = curr.amount;
          const { amount, ...other } = curr;
          if (!key) return acc;
          if (!acc[key]) {
            acc[key] = {
              ...curr,
              detailList: [
                {
                  ...other,
                },
              ],
            };
          } else {
            acc[key].detailList.push({ ...other });
          }
          return acc;
        },
        {}
      );
      const newRechargeGiftActivity = {
        ...rechargeGiftActivity,
        activityDetail: Object.values(obj).map((group: any) => {
          const shouldKeepList = group.detailList.length > 1;
          return shouldKeepList
            ? group
            : (({ detailList, ...rest }) => rest)(group);
        }),
      };
      return newRechargeGiftActivity;
    } else {
      return {};
    }
  },
});

const actions = (
  set: StoreSet<IFoxTopUpStore>,
  get: StoreGet<IFoxTopUpStore>
): IFoxTopUpAction => ({
  ...commonActions(set, get),
  verifyRechargeCode: async (params: IVerifyRechargeCodeParams) => {
    const res = await FoxTopUpAPI.verifyRechargeCode(params);
    return res;
  },
});

export const useFoxTopUpStore = create<IFoxTopUpStore>()(
  composeMiddleware(
    [devtools, immer],
    (set: StoreSet<IFoxTopUpStore>, get: StoreGet<IFoxTopUpStore>) => ({
      ...initialState(),
      ...actions(set, get),
      ...getter(get),
    })
  )
);
